export const CommerceShipConnectorsActionTypes = {
    API_RESPONSE_SUCCESS: '@@commerce_ship_connectors/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@commerce_ship_connectors/API_RESPONSE_ERROR',
    CREATE_SHOPIFY_INTEGRATION_AND_START_OAUTH_REQUEST: '@@commerce_ship_connectors/CREATE_SHOPIFY_INTEGRATION_AND_START_OAUTH_REQUEST',
};
